import React, { useContext, useEffect, useState } from "react";
import { Rows } from "./Row";
import {
    CardTableRows,
    CardTableShell,
    CardTableToolbar,
    FlexContainer,
    Toast
} from "src/components";

import { useTableHooks } from "../../../hooks/useTableHooks";
import { PageLoadingContainer } from "src/components/PageLoadingContainer";
import { getContacts } from "src/scenes/EmailCampaigns/api/contactsApi";
import HeaderCard from "src/scenes/EmailCampaigns/components/HeaderCard";
import { ActionButton } from "src/scenes/EmailCampaigns/components/style";
import { UserContext } from "src/scenes/App/UserContext";
import { getEmailAudienceDisplayName } from "src/scenes/EmailCampaigns/constants";

export const ContactsTable = (props) => {
    const { countryCode } = useContext(UserContext);
    const { selectedAudience, contactUuidFilter, setIsViewingContacts, setSelectedAction, isViewingContacts = false } = props;
    const [contactsIsFetching, setContactsIsFetching] = useState(false);
    const [contactsList, setContactsList] = useState([]);

    const getAllContacts = async () => {
        setContactsIsFetching(true);
        try {
            const response = await getContacts(selectedAudience.uuid);
            if (contactUuidFilter) {
                setContactsList(response.contacts.filter(contact => contactUuidFilter.includes(contact.uuid)));
            } else {
                setContactsList(response.contacts);
            }
        } catch (error) {
            console.log("Error: ", error);
            Toast.error("Error occurred while fetching contacts.");
        } finally {
            setContactsIsFetching(false);
        }
    };

    useEffect(() => {
        getAllContacts();
    }, []);

    const SortableColumns = {
        firstName: 1,
        lastName: 2,
        email: 3,
        mobile: 4,
        reference: 5,
    };

    const { tableData, toggleItemSelection, isItemSelected, handleSortColumn } =
        useTableHooks(contactsList, SortableColumns);

    const isASortableColumn = (index) => index >= 0;

    if (contactsIsFetching) return <PageLoadingContainer maxWidth={"1112px"} minHeight={"45rem"} height={"45rem"} />;
    return (
        <CardTableShell maxWidth="1112px" minHeight="45rem">
            <CardTableToolbar>
                <FlexContainer padding="20px" width="100%">
                    <HeaderCard
                        title={getEmailAudienceDisplayName(selectedAudience?.name)}
                        subtitle={"Contacts Available"}
                        quantity={contactsList && contactsList.length}
                    />
                </FlexContainer>
            </CardTableToolbar>
            <CardTableRows maxHeight="34rem" minHeight="30rem">
                <Rows
                    tableData={tableData}
                    onToggle={(contact) => toggleItemSelection(contact)}
                    isSelected={isItemSelected}
                    countryCode={countryCode}
                    onSort={handleSortColumn}
                    isSortable={isASortableColumn}
                    isViewingContacts={isViewingContacts}
                />
            </CardTableRows>
            <FlexContainer
                direction="row"
                tDirection="row"
                style={{ justifyContent: "flex-end" }}
                padding="20px 20px 30px 0px"
                gap="10px"
            >
                <FlexContainer
                    direction="row"
                    tDirection="row"
                    gap="20px"
                    style={{ justifyContent: "flex-end" }}
                >
                    <FlexContainer width="140px" mWidth="100%">
                        <ActionButton
                            type="button"
                            width="100%"
                            height="39px"
                            color="#000000"
                            backgroundColor="#FFFFFF"
                            onClick={() => {
                                setIsViewingContacts(false);
                                if (setSelectedAction) setSelectedAction({});
                            }}
                        >
                            Close
                        </ActionButton>
                    </FlexContainer>
                </FlexContainer>
            </FlexContainer>
        </CardTableShell>
    );
};
